<script setup>
import {useRoute} from "vue-router";
import {ref, onMounted} from 'vue'
import axios from "axios";
const route = useRoute()
const confirm = ref([])

onMounted( ()=>{
  init()
})

const init = async () => {
  const url = process.env.VUE_APP_API + 'confirm-email.php'
  await axios
      .get(`${url}?id=${route.params.id}`)
      .then(response => (confirm.value = response.data))
      .catch(error => alert(error));

      //console.log(confirm.value)

  //isEmailExist.value = confirm.value.email !== 'NOT_FOUND';
}

</script>
<template>

    <div v-if="confirm['status'] === 'SUCCESS'" class="card card-outline card-success">
      <div class="card-body text-center">
        <v-icon
            class="success-icon--green mb-3"
            icon="mdi:check-circle-outline"
        ></v-icon>
          <h5>Регистрация завершена</h5>
          После модерации данных на электронный адрес
          <h5 class="pt-2">{{ confirm['email'] }}</h5>
          будет выслан пароль для доступа в личный кабинет.
      </div>
    </div>

    <div v-else-if="confirm['status'] === 'NOT_FOUND'" class="card card-outline card-danger">
      <div class="card-body text-center">
        <v-icon
            class="error-icon--red mb-3"
            icon="mdi:alert-circle-outline"
        ></v-icon>
        <p>Ссылка устарела или используется неправильный регистрационный код.</p>
      </div>
    </div>

    <div v-else class="d-flex justify-content-center">
      <div class="spinner-border text-primary m-4" role="status"></div>
    </div>

</template>
<style scoped>
.login-type {
  padding:8px 12px;
  cursor:pointer;
  border-radius: 5px;
  border: 1px solid #e9ecef;
  background-color: #fff;
}
.login-type-active {
  background-color: #e9ecef
}
</style>